// Date helpers for events
export const DAYS_SHORT_ES = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

export const MONTHS_SHORT_ES = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
];
const MONTHS_LONG_ES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

/** Parse YYYY-MM-DD as local Date (no timezone shift) */
export function parseISODate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split("T")[0].split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}

/**
 * Format a date range, always showing the year.
 *   single:          "11 mayo 2026"
 *   same month/year: "11–14 mayo 2026"
 *   diff months:     "30 mayo – 2 junio 2026"
 *   diff years:      "28 dic 2025 – 3 ene 2026"
 *
 * @param {string} startISO  YYYY-MM-DD
 * @param {string} [endISO]  YYYY-MM-DD (optional)
 * @param {{ short?: boolean }} [opts]  use abbreviated month names
 */
export function formatDateRange(startISO, endISO, { short: useShort = false } = {}) {
  const s = parseISODate(startISO);
  if (!s) return "";
  const e = endISO && endISO !== startISO ? parseISODate(endISO) : null;

  const MONTHS = useShort ? MONTHS_SHORT_ES : MONTHS_LONG_ES;
  const sY = s.getFullYear();

  if (!e) {
    return `${s.getDate()} ${MONTHS[s.getMonth()]} ${sY}`;
  }

  const eY = e.getFullYear();

  if (sY !== eY) {
    return `${s.getDate()} ${MONTHS_SHORT_ES[s.getMonth()]} ${sY} – ${e.getDate()} ${MONTHS_SHORT_ES[e.getMonth()]} ${eY}`;
  }
  if (s.getMonth() !== e.getMonth()) {
    return `${s.getDate()} ${MONTHS[s.getMonth()]} – ${e.getDate()} ${MONTHS[e.getMonth()]} ${eY}`;
  }
  return `${s.getDate()}–${e.getDate()} ${MONTHS[s.getMonth()]} ${eY}`;
}

/** Returns true if `dateISO` is within [start, end] inclusive (end optional). */
export function isWithinRange(dateISO, startISO, endISO) {
  if (!startISO) return false;
  if (!endISO) return dateISO === startISO;
  return dateISO >= startISO && dateISO <= endISO;
}

/** Returns true if event spans `dateISO` */
export function eventCoversDate(ev, dateISO) {
  return isWithinRange(dateISO, ev.date, ev.end_date);
}
